<template>
    <span :class="$style[`size_${props.size}`]">
        <input
            :id="id"
            type="checkbox"
            :class="[$style.checkbox, { [$style.hovered]: hovered }]"
            :checked="checked"
            :disabled="disabled"
            @change="onChange"
        />
        <label
            :for="id"
            :class="$style.label"
        >
            <Icon
                name="check"
                :class="$style.checkIcon"
            />
        </label>
    </span>
</template>
<script setup lang="ts">
import Icon from '@/components_new/Icon/Icon.vue'

const props = defineProps<{
    checked?: boolean
    disabled?: boolean
    size: 'xs' | 's' | 'm' | 'l'
    hovered?: boolean
    id: string
}>()

const emit = defineEmits<{ (e: 'change', data: Event): void }>()

function onChange(event: Event) {
    emit('change', event)
}
</script>
<style module>
.size_xs {
    --width: 16px;
    --radius: 4px;
}
.size_s {
    --width: 20px;
    --radius: 4px;
}
.size_m {
    --width: 24px;
    --radius: 6px;
}
.size_l {
    --width: 32px;
    --radius: 8px;
}

.checkbox {
    display: none;
}

.label {
    display: flex;
    border-radius: var(--radius-4);
    width: var(--width);
    height: var(--width);
    outline: 1px solid var(--white-40);
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition:
        border-color 0.3s ease,
        background-color 0.3s ease;
}

.checkIcon {
    display: none;
    color: var(--white);
}

.size_xs .checkIcon {
    width: 12px;
    height: 12px;
}
.size_s .checkIcon {
    width: 16px;
    height: 16px;
}
.size_m .checkIcon {
    width: 20px;
    height: 20px;
}
.size_l .checkIcon {
    width: 24px;
    height: 24px;
}

.checkbox:hover + .label,
.hovered + .label {
    border-color: var(--purple-400);
}

.checkbox:checked + .label {
    border: none;
    background-color: var(--purple-400);
    position: relative;
}

.checkbox:disabled + .label {
    background-color: var(--carbon-400);
}

.checkbox:checked + .label .checkIcon {
    display: block;
}
</style>
